import { atom } from "recoil";

const photoFiveState =atom({
    key: 'photoFive',
    default: false
})

export default photoFiveState